import EzController from 'controllers/ez-base-controller';

export default class ToggleClassController extends EzController {
  static classes = ['name'];

  static targets = ['element'];

  // #region Types
  declare readonly elementTargets:HTMLElement[]

  declare readonly nameClasses:string[]
  // #endregion

  on() {
    this.elementTargets.forEach((target) => {
      target.classList.add(...this.nameClasses);
    });
  }

  off() {
    this.elementTargets.forEach((target) => {
      target.classList.remove(...this.nameClasses);
    });
  }
}
